<template>
    <rkm-tabs
        v-model="tabIndex"
        :tab-refs="tabRefs"
    >
        <rkm-tab title="Identificação">
            <rkm-form
                ref="FormIdentificacao"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="form.prontuario"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <rkm-form-input
                            :validations="validations.nome"
                            label="Nome"
                            uppercase
                            v-model="model.cidadao.nome"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.nomeSocial"
                            label="Nome social"
                            uppercase
                            v-model="model.cidadao.nomeSocial"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disablePreferenciaNome"
                            :options="form.cidadao.identificacao.preferenciasNome"
                            :validations="validations.preferenciaNome"
                            label="Prefere ser chamado pelo"
                            text-field="descricao"
                            v-model="model.cidadao.preferenciaNomeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :max-date="form.cidadao.dataAtual"
                            :validations="validations.dataNascimento"
                            label="Data de nascimento"
                            v-model="model.cidadao.dataNascimento"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            label="Data de óbito"
                            v-model="model.cidadao.dataObito"
                            disabled
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.cidadao.identificacao.sexos"
                            :validations="validations.sexo"
                            label="Sexo"
                            text-field="descricao"
                            v-model="model.cidadao.sexoId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-input
                            :validations="validations.nomeMae"
                            label="Nome da mãe"
                            uppercase
                            v-model="model.cidadao.nomeMae"
                            :disabled="model.cidadao.desconheceNomeMae"
                        >
                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-checkbox v-model="model.cidadao.desconheceNomeMae">
                                        Desconhece
                                    </rkm-form-checkbox>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input>
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.cidadao.identificacao.racasCores"
                            :validations="validations.racaCor"
                            label="Raça/cor"
                            text-field="descricao"
                            v-model="model.cidadao.racaCorId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="!isRequiredEtniaIndigena"
                            :options="form.cidadao.identificacao.etniasIndigenas"
                            :validations="validations.etniaIndigena"
                            label="Etnia indígena"
                            text-field="descricao"
                            v-model="model.cidadao.etniaIndigenaId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.cns"
                            label="CNS"
                            v-mask="mask.cns"
                            v-model="model.cidadao.cns"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.cpf"
                            label="CPF"
                            v-mask="mask.cpf"
                            v-model="model.cidadao.cpf"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="RG"
                            v-model="model.cidadao.documentos.carteiraIdentidade.numero"
                            uppercase
                            :validations="validations.rg"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.orgaoEmissor"
                            label="Orgão emissor"
                            v-model="model.cidadao.documentos.carteiraIdentidade.orgaoEmissor"
                            :disabled="!model.cidadao.documentos.carteiraIdentidade.numero"
                            uppercase
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="form.cidadao.identificacao.nacionalidades"
                            :validations="validations.nacionalidade"
                            label="Nacionalidade"
                            text-field="descricao"
                            v-model="model.cidadao.nacionalidadeId"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :options="classificacoes"
                            label="Classificação"
                            text-field="descricao"
                            v-model="model.classificacaoId"
                            :validations="validations.classificacao"
                            value-field="id"
                            show-default-option
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-tab>

        <rkm-tab title="Telefone">
            <rkm-form show-legend>
                <CidadaoTelefone
                    ref="CidadaoTelefone"
                    :telefones="model.cidadao.telefones"
                />
            </rkm-form>
        </rkm-tab>

        <rkm-tab title="Endereço">
            <rkm-form
                ref="FormEndereco"
                show-legend
            >
                <CidadaoEndereco
                    ref="CidadaoEndereco"
                    :termos-invalidos="form.cidadao.termosInvalidos"
                    :data-atual="form.cidadao.dataAtual"
                    :form="form.cidadao.endereco"
                    :isPermissaoEndereco="form.isPermissaoEndereco"
                    :model="model.cidadao"
                />
            </rkm-form>
        </rkm-tab>
    </rkm-tabs>
</template>

<script>

// Components.
import CidadaoTelefone from '@/components/cadastro/cidadao/Telefone'
import CidadaoEndereco from '@/components/cadastro/cidadao/Endereco'

// Vuex.
import { mapGetters, mapActions } from 'vuex'

// Mixins.
import { cadastroCidadaoForm, repository, stringCase, object, error, mask, unmask, data } from '@/mixins'

// Enuns.
import nacionalidade from '@/enums/cadastro/cidadao/nacionalidade'
import racaCor from '@/enums/cadastro/cidadao/racaCor'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'
import classificacao from '@/enums/cadastro/paciente/classificacao'

export default {
    mixins: [ cadastroCidadaoForm, repository, stringCase, object, error, mask, unmask, data ],
    components: { CidadaoTelefone, CidadaoEndereco },
    props: {
        id: { type: Number },
        semDocumentos: { type: Boolean, default: false },
        semDocumentosEm: { type: Date, default: null },
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
        repositories: {
            paciente: null,
        },
        form: {
            classificacoes: [],
            prontuario: null,
        },
        model: {
            id: null,
            cadastroSimplificado: true,
            classificacaoId: null,
            unidadeId: null,
        },
        enums: {
            nacionalidade,
            racaCor,
            preferenciaNome,
            classificacao,
        }
    }),
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    min: 6,
                    max: 150,
                    termo_invalido: this.form.cidadao.termosInvalidos,
                    name: true,
                },
                nomeSocial: {
                    min: 3,
                    max: 150,
                    termo_invalido: this.form.cidadao.termosInvalidos,
                },
                preferenciaNome: {
                    required: true
                },
                dataNascimento: {
                    required: true
                },
                sexo: {
                    required: true
                },
                nomeMae: {
                    required: !this.model.cidadao.desconheceNomeMae,
                    min: 8,
                    max: 150,
                    termo_invalido: this.form.cidadao.termosInvalidos,
                    name: true
                },
                racaCor: {
                    required: true
                },
                etniaIndigena: {
                    required: this.isRequiredEtniaIndigena
                },
                cns: {
                    min_max_without_mask: 15,
                    cns: true,
                },
                cpf: {
                    required: !this.semDocumentos,
                    min_max_without_mask: 11,
                    cpf: true
                },
                rg: {
                    min: 6,
                    max: 15
                },
                nacionalidade: {
                    required: true
                },
                classificacao: {
                    required: true
                },
                orgaoEmissor: {
                    min: 5,
                    max: 8,
                },
            }
        },
        disablePreferenciaNome() {

            return this.isNullOrEmptyString(this.model.cidadao.nome)
                || this.isNullOrEmptyString(this.model.cidadao.nomeSocial)
        },
        isRequiredEtniaIndigena() {

            return this.model.cidadao.racaCorId === this.enums.racaCor.INDIGENA
                && this.model.cidadao.nacionalidadeId === this.enums.nacionalidade.BRASILEIRO
        },
        classificacoes() {

            if (this.model.classificacaoId === this.enums.classificacao.MUNICIPE) {

                return this.form.classificacoes
            }

            return this.form.classificacoes.filter(c => c.id !== this.enums.classificacao.MUNICIPE)
        }
    },
    methods: {
        ...mapGetters(['getLotacao']),
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.$nextTick().then(() => {

                this.setLoading()

                const request = this.id
                    ? this.repositories.paciente.edit(this.id)
                    : this.repositories.paciente.create()

                request
                    .then(({ data }) => this.setData(data.form, data.model || null))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        setData(form, model) {

            if (form.cidadao) {

                this.setCidadaoData(form.cidadao, model ? model.cidadao : null)
            }

            this.form.classificacoes = form.classificacoes
            this.form.isPermissaoEndereco = form.isPermissaoEndereco

            if (!model) return

            this.model.id = this.id
            this.form.prontuario = form.prontuario
            this.model.classificacaoId = model.classificacaoId
            this.model.unidadeId = model.unidadeId
        },
        save() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.paciente.update(this.id, this.prepareData(), { with: 'cidadao.sexo' })
                        : this.repositories.paciente.store(this.prepareData(), { with: 'cidadao.sexo' })

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
        prepareData() {

            const paciente = this.clone(this.model)

            delete paciente.id

            if (this.semDocumentos) {

                paciente.semDocumentosEm = this.getFormatedDate(this.semDocumentosEm, 'YYYY-MM-DD HH:mm:ss')
            }

            paciente.unidadeId = paciente.unidadeId ?? this.getLotacao().unidadeId
            paciente.cidadao = this.prepareCidadaoData()

            return this.camelObjectKeysToSnakeRecursive(paciente)
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.FormIdentificacao,
            this.$refs.CidadaoTelefone,
            this.$refs.FormEndereco,
        ]
    },
    watch: {
        'model.cidadao.desconheceNomeMae': function (desconhece) {

            if (desconhece) {

                this.model.cidadao.nomeMae = ''
            }
        },
        disablePreferenciaNome(disable) {

            if (disable) {

                this.model.cidadao.preferenciaNomeId = this.enums.preferenciaNome.NOME
            }
        },
        isRequiredEtniaIndigena(required) {

            if (!required) {

                this.model.cidadao.etniaIndigenaId = null
            }
        },
    },
    created() {

        this.repositories.paciente = this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')

        this.model.cidadao.cadastroSimplificado = true
        this.model.cidadao.nacionalidadeId = this.enums.nacionalidade.BRASILEIRO
        this.model.cidadao.preferenciaNomeId = this.enums.preferenciaNome.NOME
        this.model.cidadao.cpfNaoPertenceAoCidadao = null
        this.model.cidadao.desconheceNomePai = true
        this.model.cidadao.frequentaEscola = null
    }
}
</script>